if (!customElements.get('deferred-collection-image')) {
  customElements.define('deferred-collection-image', class extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('template')) return;
      const reveal = () => {
        const template = this.querySelector('template');
        if (!template) return;
        const content = template.content.cloneNode(true);
        content.querySelectorAll('img').forEach(image => {
          image.loading = 'eager';
          image.addEventListener('load', () => {
            image.classList.remove('is-loading');
            image.closest('figure')?.classList.remove('is-loading');
          }, {once: true});
        });
        this.replaceChildren(content);
        this.observer?.disconnect();
      };
      if (!('IntersectionObserver' in window)) { reveal(); return; }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) reveal();
      }, {rootMargin: '200px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
